import { StateSpecificContentModelService } from "app/core/models/state-specific-content-model.service";
import { ScreenControllerService } from "./../../controls/screen-controller.service";
import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Input,
	SimpleChanges,
	HostListener,
} from "@angular/core";
import { BaseView } from "../base-view";
import { DescriptorModelService } from "../../models/descriptor-model.service";
import { Descriptor } from "../../vo/descriptor";
import { Subscription } from "rxjs";
import { CourseContextModelService } from "../../models/course-context-model.service";
import { UtilityScripts } from "../../../helpers/utility-scripts";
import { ApplicationModel } from "../../models/application.model";
import { CourseTimerService } from "app/services/course-timer.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { AppConstants } from "../../vo/app-constants";
import { OrientationModelService } from "app/core/models/orientation-model.service";

@Component({
	selector: "app-navigation",
	templateUrl: "./navigation.component.html",
	styleUrls: ["./navigation.component.css"],
})
export class NavigationComponent extends BaseView {
	protected nextButton: string = "Next";
	protected backButton: string = "Back";
	protected iagreeButton: string = "I Agree";
	public curPageNum: number;
	public totalPagesNum: number;
	public windowScreenHeight: number;
	private percentComplete: string = "";
	private isScroll: Boolean = false;
	private desiredPosition: any;
	private currentPositionClass = "positionCSS";
	private screenHeight: any;
	private minusValue: number = 70;
	private floatBtnTimeout: any;

	@Input() enabledNext: boolean;
	@Input() enabledContinue: boolean;
	@Input() enabledIagree: boolean;
	@Input() isRubricLoaded: boolean;
	@Output() navigate: EventEmitter<string> = new EventEmitter();
	private descriptorSubscription: Subscription;
	constructor(
		private descriptorModelService: DescriptorModelService,
		private screenController: ScreenControllerService,
		private stateSpecificModel: StateSpecificContentModelService,
		private courseContextModel: CourseContextModelService,
		private courseTimer: CourseTimerService,
		private orientationModel: OrientationModelService
	) {
		super();
	}

	@HostListener("window:scroll", ["$event"])
	scrollHandler(event) {
		if (this.isScroll) {
			if (
				document.body.scrollHeight ==
				Math.ceil(window.scrollY + window.innerHeight)
			) {
				this.currentPositionClass = "resetCSS";
			} else {
				this.currentPositionClass = "positionCSS";
			}
		}
	}

	public ngOnInit(): void {
		this.getSubscription();
	}
	ngAfterViewChecked() {
		if (this.enabledNext == true) {
			this.setFloatPosition();
			this.isScroll = true;
		} else {
			this.positionReset();
		}
	}
	public ngOnChanges(changes: SimpleChanges): void {
		if (this.enabledNext == true) {
			// added 400ms for geting proper rubric height
			this.floatBtnTimeout = setTimeout(() => {
				this.setFloatPosition();
				this.isScroll = true;
			}, 400);
		} else {
			this.floatBtnTimeout && clearTimeout(this.floatBtnTimeout);
		}
		if (
			changes.hasOwnProperty("enabledNext") &&
			changes["enabledNext"]["currentValue"] != undefined &&
			changes["enabledNext"]["currentValue"] == true
		) {
			this.setFloatPosition();
			this.isScroll = true;
		} else {
			this.positionReset();
		}
	}
	public setFloatPosition() {
		if (
			document.body.scrollHeight ==
			Math.ceil(window.scrollY + window.innerHeight)
		) {
			this.currentPositionClass = "resetCSS";
		} else {
			this.currentPositionClass = "positionCSS";
		}
	}
	public calculateScreenHeight() {
		this.windowScreenHeight = window.outerHeight;
		if (
			(window.orientation == 90 || window.orientation == -90) &&
			window.screen.width <= UtilityScripts.iPadWidth
		) {
			if (/iPhone|ipad/i.test(navigator.userAgent)) {
				this.windowScreenHeight = window.screen.width;
				return this.windowScreenHeight;
			} else {
				this.windowScreenHeight = window.outerHeight;
				return this.windowScreenHeight;
			}
		} else if (
			window.screen.width > UtilityScripts.iPadWidth &&
			window.screen.width <= this.windowScreenHeight
		) {
			this.windowScreenHeight = window.outerHeight;
			return this.windowScreenHeight;
		}
		return this.windowScreenHeight;
	}
	/*private positionChanged(){
    this.currentPositionClass = "positionCSS";
    this.isScroll = true;
  }*/
	private positionReset() {
		this.currentPositionClass = "resetCSS";
		this.desiredPosition = 0;
		this.isScroll = false;
	}

	private getSubscription() {
		this.descriptorSubscription =
			this.descriptorModelService.notifier.subscribe((data) =>
				this.descriptorUpdate()
			);
	}

	public goBack() {
		this.stateSpecificModel.bShowStateSpecificIcon = false;
		this.navigate.emit("back");
	}

	public goNext() {
		//window.removeEventListener('scroll', function(){});
		//this.positionReset();
		this.stateSpecificModel.bShowStateSpecificIcon = false;
		this.navigate.emit("next");
	}
	public continuePage() {
		this.navigate.emit("continue");
	}

	private descriptorUpdate() {
		this.backButton = UtilityScripts.removeHTMLTags(
			this.getDescriptorTextById("back_str")
		);
		this.nextButton = UtilityScripts.removeHTMLTags(
			this.getDescriptorTextById("next_str")
		);
		this.iagreeButton = UtilityScripts.removeHTMLTags(
			this.getDescriptorTextById("dashboardagree")
		);
	}

	public get enabledBack(): boolean {
		return this.courseContextModel.currentPage !== 0;
	}

	private getDescriptorTextById(id: string): string {
		const descriptor: Descriptor = this.descriptorModelService.txtFields.find(
			(item) => item.id === id
		);
		if (descriptor) {
			return descriptor.value;
		}
		return ``;
	}

	public get nextButtonVal(): string {
		return this.nextButton;
	}

	public get backButtonVal(): string {
		return this.backButton;
	}

	public set backButtonVal(value: string) {
		this.backButton = value;
	}

	public set nextButtonVal(value: string) {
		this.nextButton = value;
	}
	public get iAgreeButtonVal() {
		return this.iagreeButton;
	}
	public set iAgreeButtonVal(val: string) {
		this.iagreeButton = val;
	}
	public get textDirection() {
		return ApplicationModel.instance.flowDirection;
	}

	public get pageComplete(): boolean {
		return (
			this.screenController.coursePageVal &&
			this.screenController.coursePageVal.status === "c"
		);
	}

	public IAgreeButtonClickHandler() {
		this.navigate.emit("iAgreeBtnClick");
	}

	public restricCertificate(): Boolean {
		if (this.enabledNext) {
			if (
				TrackingManager.instance.trackingVO.lessonStatus ==
				TrackingManager.instance.config.completedVal
			) {
				return false;
			} else if (
				(ApplicationModel.instance.nextExpectedRubric == "certificate" ||
					ApplicationModel.instance.nextExpectedRubric ==
						"certificate_adaptive") &&
				this.courseTimer.minimumTimeint > 0 &&
				!this.courseTimer.isTimeMet()
			)
				return true;
			else return false;
		} else return false;
	}
}
